import React from 'react'

export default function PageHeader({ children, icon }) {
  const styles = {
    container: {
      display: 'flex',
      paddingBottom: 10,
      textTransform: 'uppercase',
      borderBottom: '1px solid #14B0BF',
      color: '#14B0BF',
    },
    icon: {
      width: 30,
    },
    title: {
      paddingLeft: 10,
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }
  return (
    <header style={styles.container}>
      {icon ? <div style={{ ...styles.icon, ...styles.center }}>{icon}</div> : null}
      <div style={{ ...styles.title, ...styles.center }}>{children}</div>
    </header>
  )
}
